/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IPageContainer contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum imageAlignment {
    left = 'left',
    right = 'right'
}

export interface IPageContainerConfig extends Msdyn365.IModuleConfig {
    image?: Msdyn365.IImageData;
    imageAlignment?: imageAlignment;
    title?: string;
    description?: Msdyn365.RichText;
}

export interface IPageContainerResources {
    resourceKey: string;
}

export interface IPageContainerProps<T> extends Msdyn365.IModule<T> {
    resources: IPageContainerResources;
    config: IPageContainerConfig;
}
